import Footer from "../components/common/footer";
import About from "../components/home/about";
import { Helmet } from "react-helmet";
import Offer from "../components/home/offer";
import Transform from "../components/home/transform";
import Cta from "../components/home/cta";
import Portfolio from "../components/home/portfolio";
import Faq from "../components/home/faq";
import Mission from "../components/home/mission";
import Tools from "../components/home/tools";
import HeaderTwo from "../components/common/headerTwo";
import HeroNewSeo from "../components/home/heroNewSeo";

interface HomeSeoProps {
  city?: string; // Opcjonalny parametr city
}

function HomeSeo({ city }: HomeSeoProps) {
  // Domyślna wartość, jeśli city nie jest przekazane
  const displayCity = city || "Twoim mieście";

  return (
    <>
      <Helmet>
        <title>
          {`Przygotowanie działki pod budowę, mulczowanie i zakładanie ogrodów ${displayCity} | DRZEWUS`}
        </title>
        <meta
          name="title"
          content={`Przygotowanie działki pod budowę, mulczowanie i zakładanie ogrodów ${displayCity} | DRZEWUS`}
        />
        <meta
          name="description"
          content={`DRZEWUS wykonuje mulczowanie, karczowanie i oczyszczanie działek pod budowę oraz zakładanie ogrodów na terenie miasta ${displayCity} i okolic. Przygotowujemy teren pod inwestycje, domy i zieleń.`}
          key="desc"
        />
        <meta
          property="og:title"
          content={`Przygotowanie działki pod budowę, mulczowanie i zakładanie ogrodów ${displayCity} | DRZEWUS`}
        />
        <meta
          property="og:description"
          content={`DRZEWUS wykonuje mulczowanie, karczowanie i oczyszczanie działek pod budowę oraz zakładanie ogrodów na terenie miasta ${displayCity} i okolic. Przygotowujemy teren pod inwestycje, domy i zieleń.`}
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <HeroNewSeo city={city} /> {/* Przekazanie city do HeroNew */}
        <About />
        <Offer />
        <Transform />
        <Cta />
        <Portfolio />
        <Mission />
        <Faq />
        <Tools />
      </main>
      <Footer />
    </>
  );
}

export default HomeSeo;
